/* global angular */
( function () {
	'use strict';

	function exportService () {
		function exportOptions () {
			return [ {
				'value' : true,
				'name'  : 'Scoring',
				'index' : 1
			}, {
				'value' : true,
				'name'  : 'Signature Lines',
				'index' : 2
			}, {
				'value'   : true,
				'name'    : 'Observation Details',
				'index'   : 3,
				'options' : [ {
					'value' : true,
					'name'  : 'Evidence',
					'index' : 1
				}, {
					'value' : true,
					'name'  : 'Rubric proficiency descriptions',
					'index' : 2
				}, {
					'value' : true,
					'name'  : 'Feedback',
					'index' : 3
				} ]
			} ];
		}

		function promoteOptions ( prev, cur ) {
			return prev.concat( cur.options );
		}

		function getValues ( prev, cur ) {
			prev[ cur.name ] = cur.value;
			return prev;
		}

		function formatShowOptions ( arr ) {
			return arr.reduce( promoteOptions, arr ).filter( Boolean ).reduce( getValues, {} );
		}

		return {
			'exportOptions'     : exportOptions,
			'formatShowOptions' : formatShowOptions
		};
	}

	angular
		.module( 'app.observations' )
		.factory( 'exportService', exportService );
} )( );
